import { axiosClient } from "./axiosClient"

export const OPERATION_PATH = '/api/v1/operation'

export const addOperation = (body) => {
    return axiosClient.post(OPERATION_PATH, body)
}

export const updateOperation = (id, body) => {
    return axiosClient.put(`${OPERATION_PATH}/${id}`, body)
}

export const deleteOperation = (id) => {
    return axiosClient.delete(`${OPERATION_PATH}/${id}`)
}

export const getOperationById = (id) => {
    return axiosClient.get(`${OPERATION_PATH}/${id}`)
}

export const getPageOperations = ({ search = "", lastId = '', id = "", code = '', name = '' }) => {
    return axiosClient.get(`${OPERATION_PATH}/page?search=${search}&lastId=${lastId}&id=${id}&code=${code}&name=${name}`)
}
